module.exports = __webpack_public_path__ + "static/profile-7d1e4b85aa5656a7a0c4d9ec822e738e.png";